import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

// Renders Google Identity Services' official button. On success it yields a
// `credential` (the ID-token JWT) which the API verifies at
// /account/authenticate-google. Must be rendered inside a <GoogleOAuthProvider>.
export default function GoogleSignInButton({ onCredential, theme }) {
    return (
        <div className="flex w-full justify-center">
            <GoogleLogin
                onSuccess={(response) => onCredential(response && response.credential)}
                onError={() => onCredential(null)}
                theme={theme === 'dark' ? 'filled_black' : 'outline'}
                text="continue_with"
                shape="rectangular"
                size="large"
                locale="ro"
                width="320"
            />
        </div>
    );
}
